import React, { useState } from 'react';

const Step8Features = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.features || []);

  const options = [
    { value: 'freckles', label: 'Freckles', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/PAGE8-Freckles%20.webp' },
    { value: 'tattoos', label: 'Tattoos', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page8-tatto.webp' },
    { value: 'makeup', label: 'Makeup', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page8-Makeup.webp' },
    { value: 'no-makeup', label: 'No Makeup', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page-8Nomakeup.webp' }
  ];

  const handleSelect = (value) => {
    setSelected(prev => {
      if (prev.includes(value)) {
        return prev.filter(v => v !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  const handleNext = () => {
    onNext({ 
      extraFields: { 
        ...currentData.extraFields, 
        features: selected 
      } 
    });
  };

  return (
    <div className="step step-selection">
      <h2 className="step-title">Any specific preferences?</h2>
      <p className="step-subtitle">You can choose all that excites you.</p>
      <div className="options-grid grid-2x2">
        {options.map(option => (
          <div
            key={option.value}
            className={`option-card ${selected.includes(option.value) ? 'selected' : ''}`}
            onClick={() => handleSelect(option.value)}
          >
            <img src={option.image} alt={option.label} className="option-image" />
            <div className="option-label">{option.label}</div>
          </div>
        ))}
      </div>
      <button 
        onClick={handleNext}
        className="next-button"
        disabled={selected.length === 0}
      >
        Next
      </button>
    </div>
  );
};

export default Step8Features;